import { ErrorHandler, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

/**
 * Sposta tutti gli Error sul logger
 */
@Injectable()
export class LoggingErrorHandler implements ErrorHandler {
  constructor(private readonly logger: NGXLogger) {}

  public handleError(error: Error): void {
    this.logger.error(error.stack);
  }
}
